require("./config/bootstrap")

/* PLUGINS */
import Vue from "vue"
import Vuex from "vuex"
import VueAWN from "vue-awesome-notifications"
import VeeValidate from "vee-validate"
import validationMessagesEn from "vee-validate/dist/locale/en"
import validationMessagesNo from "vee-validate/dist/locale/nb_NO"
import _ from "lodash"
import moment from "moment"
import VueSweetalert2 from 'vue-sweetalert2';
import VueCookies from "vue-cookies"
import App from "./modules/master/components/Master.vue"
import axios from "axios"
import eventBus from "./plugins/events"

/* CONFIGS */
import vuetify from "./config/vuetify"
import store from "./config/stores"
import router from "./config/router"
import i18n from "./config/i18n"
import { awn_notifications } from "./config/awn-notifications"
import { constants } from "./config/constants"
import { countryAlpha2 } from "./config/countryAlpha2"
import "./config/registerServiceWorker"

/* MIXINS */
import helpers from "./mixins/helpers"
import dropdowns from "./mixins/dropdowns"
import pageHeaderTitle from "./mixins/components/pageHeaderTitle"
import actionButton from "./mixins/components/actionButton"
import noLocale from "./mixins/components/noLocale"
import noAvailableSeats from "./mixins/components/noAvailableSeats"
import helpText from "./mixins/components/helpText"

/* STYLES */
import "vuetify/dist/vuetify.min.css"
import "vue-awesome-notifications/dist/styles/style.css"
import 'sweetalert2/dist/sweetalert2.min.css';
import "./assets/css/theme.scss"
import "./assets/css/styles.scss"

let locale = "no"
let user = localStorage.getItem("__crrntUser")
if (user) {
  user = JSON.parse(user)
  let setting = user.settings.find((i) => i.key == "locale")
  if (setting) {
    locale = setting.value
  }
}
i18n.locale = locale

// ==================================
// USE
// ==================================
Vue.use(Vuex)
Vue.use(VueAWN, awn_notifications)
Vue.use(VeeValidate, {
  classes: true,
  locale: locale,
  dictionary: {
    en: validationMessagesEn,
    no: validationMessagesNo
  }
})
Vue.use(VueSweetalert2);
Vue.use(eventBus)

Vue.set(Vue.prototype, "_", _)
Vue.set(Vue.prototype, "moment", moment)
Vue.set(Vue.prototype, "countryAlpha2", countryAlpha2)

Vue.use(VueCookies)
Vue.$cookies.config("1d")

// ==================================
// VEE-VALIDATE CUSTOM VALIDATION
// ==================================
VeeValidate.Validator.extend("password_strength", {
  getMessage: (field) => `The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number. Minimum of 8 characters.`,
  validate: (value) => {
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})")
    return strongRegex.test(value)
  }
})

VeeValidate.Validator.extend("minLength", {
  getMessage(field, [length]) {
    return `At least ${length} items must be selected.`
  },
  validate(value, [length]) {
    return value.length >= length
  }
})

VeeValidate.Validator.extend("validDate", {
  getMessage: (field) => `Invalid date. Format must be ${constants.DATE_FORMAT}`,
  validate(value) {
    let checker = moment(value, constants.DATE_FORMAT, true)
    return checker.isValid()
  }
})

VeeValidate.Validator.extend("validTime", {
  getMessage: (field) => `Invalid time. Format must be ${constants.TIME_FORMAT}`,
  validate(value) {
    let checker = moment(value, constants.TIME_FORMAT, true)
    return checker.isValid()
  }
})

VeeValidate.Validator.extend("validVat", {
  getMessage: (field, params, data) => {
    return data.message
  },
  validate(value, args) {
    return axios
      .post(constants.API_URL + "enrolment/validate-vat", {
        id: args.length > 0 ? Number(args[0]) : null,
        vat: value
      })
      .then((res) => {
        var ret = res.data
        return {
          valid: ret.status == "ok" ? true : false,
          data: {
            message: i18n.t("enrolments.vat_invalid", { name: ret.company_name })
          }
        }
      })
  }
})

VeeValidate.Validator.extend("no_space", {
  getMessage: (field) => `Space is not allowed.`,
  validate: (value) => {
    var bool = value.indexOf(" ") >= 0
    return !bool
  }
})

VeeValidate.Validator.extend("dynamicMax", {
  getMessage(field, args) {
    return `The ${field} field may not be greater than ${args[0]} characters(X)`
  },
  validate(value, args) {
    var text_length = Number(args[1])
    var limit_length = Number(args[0])
    return text_length > limit_length ? false : true
  }
})

VeeValidate.Validator.extend("sizePerFileInMB", {
  getMessage(field, args) {
    return `Size per file should be less than ${args[0]} Mb`
  },
  validate(files, args) {
    var mb = args[0]
    //var bytes = mb * 1024 * 1024
    var bytes = mb * 1000000

    if(!Array.isArray(files)) {
      let file = files
      files = []
      files.push(file)
    }

    return !files.some(file => file.size > bytes)
  }
})

// ==================================
// MIXINS
// ==================================
Vue.mixin({
  data: function () {
    return constants
  }
})
Vue.mixin(helpers)
Vue.mixin(dropdowns)

Vue.component("page-header-title", pageHeaderTitle)
Vue.component("action-button", actionButton)
Vue.component("no-locale", noLocale)
Vue.component("no-available-seats", noAvailableSeats)
Vue.component("help-text", helpText)

// ==================================
// DISABLE VUE IN PROD
// ==================================
if (process.env.NODE_ENV == "production") {
  Vue.config.devtools = false
  Vue.config.debug = false
  Vue.config.silent = true
  Vue.config.productionTip = false
} else {
  console.log("DEVELOPMENT MODE")
}

new Vue({
  vuetify,
  i18n,
  router,
  store,
  data: {
    window: window
  },
  render: (h) => h(App)
}).$mount("#app")
